// Utility Functions
const getItem = (orderRow) => ({
    item_id: orderRow?.articleNumber,
    item_name: orderRow?.name,
    discount: orderRow?.campaingPriceValue,
    price: orderRow?.priceValue,
    quantity: orderRow?.quantity,
});
const getOrderTotal = (orderRows) => {
    return orderRows?.reduce((acc, row) => acc + row.priceValue * row.quantity, 0) || 0;
}
const getItems = (orderRows) => orderRows?.map(getItem) || [];

// GTM Tracker Functions
const GtmTracker = () => {
    const dataLayer = window.dataLayer || [];

    const pushEvent = (eventName, ecommerceData) => {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: eventName,
            ecommerce: ecommerceData,
        });
    };

    const viewItem = (obj) => {
        pushEvent('view_item', {
            currency: obj?.currency,
            value: obj?.value,
            items: obj.items,
        });
    };

    const viewItemList = (obj) => {
        pushEvent('view_item_list', {
            currency: obj?.currency,
            item_list_name: obj?.item_list_name,
            items: obj.items,
        });
    };

    const login = (email) => {
        dataLayer.push({
            event: 'login',
            user_id: email, 
        });
    };

    return {
        viewItem,
        viewItemList,
        login
    };
};

export default GtmTracker;
